import { render, staticRenderFns } from "./AddAttachmentTab.vue?vue&type=template&id=02cad93a&scoped=true&"
import script from "./AddAttachmentTab.vue?vue&type=script&lang=js&"
export * from "./AddAttachmentTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02cad93a",
  null
  
)

export default component.exports